var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditInline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.6133 5.88658C24.1333 5.36658 24.1333 4.49992 23.6133 4.00658L20.4933 0.886582C20 0.366582 19.1333 0.366582 18.6133 0.886582L16.16 3.32658L21.16 8.32658M0 19.4999V24.4999H5L19.7467 9.73992L14.7467 4.73992L0 19.4999Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditInline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-inline.efbada87dc1e53ab2cbad845600684b2.svg";